// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/IntegrationClient.yaml
// Generated: 2026-09-17T09:15:49.195Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateIntegrationClient, UpdateIntegrationClient, IntegrationClient } from '@/types/integration/IntegrationClient';

/**
 * IntegrationClient Service
 * CRUD operations for IntegrationClient via the ABP API.
 */
export const integrationClientService = new EntityService<IntegrationClient, CreateIntegrationClient, UpdateIntegrationClient>(
  '/api/integration/integrationclient',
  'IntegrationClient',
);
